import React from 'react'

const Shipping = () => {
    return (
        <section className="shipping mb-24" id="shipping">
            <div className="container container-lg">
                <div className="row gy-4">
                    <div className="col-6 col-sm-6 col-xxl-3">
                        <div className="shipping-item flex-align gap-12 rounded-16 bg-main-50 hover-bg-main-100 transition-2">
                            <span className="w-48 h-48 flex-center rounded-circle bg-main-600 text-white text-xl flex-shrink-0">
                                <i className="ph-fill ph-car-profile" />
                            </span>
                            <div className="">
                                <h6 className="mb-0">Shipping Available</h6>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 col-sm-6 col-xxl-3">
                        <div className="shipping-item flex-align gap-12 rounded-16 bg-main-50 hover-bg-main-100 transition-2">
                            <span className="w-48 h-48 flex-center rounded-circle bg-main-600 text-white text-xl flex-shrink-0">
                                <i className="ph-fill ph-hand-heart" />
                            </span>
                            <div className="">
                                <h6 className="mb-0">100% Satisfaction</h6>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 col-sm-6 col-xxl-3">
                        <div className="shipping-item flex-align gap-12 rounded-16 bg-main-50 hover-bg-main-100 transition-2">
                            <span className="w-48 h-48 flex-center rounded-circle bg-main-600 text-white text-xl flex-shrink-0">
                                <i className="ph-fill ph-credit-card" />
                            </span>
                            <div className="">
                                <h6 className="mb-0">Secure Payments</h6>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 col-sm-6 col-xxl-3">
                        <div className="shipping-item flex-align gap-12 rounded-16 bg-main-50 hover-bg-main-100 transition-2">
                            <span className="w-48 h-48 flex-center rounded-circle bg-main-600 text-white text-xl flex-shrink-0">
                                <i className="ph-fill ph-chats" />
                            </span>
                            <div className="">
                                <h6 className="mb-0">24/7 Support</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    )
}

export default Shipping